class FeedCalculator extends HTMLElement {
  constructor() {
    super();
    this.weight = this.querySelector("#weight");
    this.age = this.querySelector("#age");
    this.activity = this.querySelector("#activity");
    this.gender = this.querySelector("#gender");
    this.inputs = this.querySelectorAll(".calculator-input");
    this.submit = this.querySelector("#submitCalculator");
    this.form = this.querySelector("#calculatorForm");
    this.form?.addEventListener("submit", this.calculate.bind(this));
    this.calculatorResult = this.querySelector(".calculator-result");
    this.button = this.querySelector('.calculator-result__button')
    this.summary = this.querySelector(".calculator-result__summary");
    this.image = this.querySelector(".calculator-image");

    this.nutrientsPercentage = [
      {
        name: "meat",
        low: "40",
        high: "50",
      },
      {
        name: "guts",
        low: "10",
        high: "15",
      },
      {
        name: "bones",
        low: "10",
        high: "15",
      },
      {
        name: "side",
        low: "10",
        high: "20",
      },
      {
        name: "fat",
        low: "20",
        high: "25",
      },
    ];
  }

  calculate(event) {
    event.preventDefault();
    const weight = this.weight?.value;
    const age = this.querySelector(`option[value="${this.age?.value}"]`);
    const activity = this.querySelector(
      `option[value="${this.activity?.value}"]`
    );
    const gender = this.querySelector(`option[value="${this.gender?.value}"]`);
    const ageCoefficient = parseFloat(age?.dataset.coefficient);
    const activityCoefficient = parseFloat(activity?.dataset.coefficient);
    const genderCoefficient = parseFloat(gender?.dataset.coefficient);
    let average =
      (ageCoefficient + genderCoefficient + activityCoefficient) / 3;
    let portionGrams = ((weight / 100) * average * 1000).toFixed(0);

    this.updateSummary(
      weight,
      age?.textContent,
      activity?.textContent,
      gender?.textContent
    );

    this.updateChart(portionGrams);
    calculateProductRecommendationsDosage();
  }

  updateSummary(weight, age, activity, gender) {
    this.querySelector("#weightResult").textContent = weight + " kg";
    this.querySelector("#ageResult").textContent = age;
    this.querySelector("#activityResult").textContent = activity;
    this.querySelector("#genderResult").textContent = gender;
  }

  updateChart(portionGrams) {
    this.image?.classList.add("hidden");
    this.calculatorResult?.classList.remove("hidden");
    this.button?.classList.remove("hidden");
    this.nutrientsPercentage.forEach((nutrient) => {
      const low = (portionGrams * nutrient.low) / 100;
      const high = (portionGrams * nutrient.high) / 100;
      const average = (low + high) / 2;
      const nutrientElement = this.querySelector(`#${nutrient.name}`);
      if (nutrientElement) {
        nutrientElement.querySelector(
          ".chart-item__value"
        ).textContent = `${low.toFixed(0)} - ${high.toFixed()}g`;

        setTimeout(() => {
          nutrientElement.querySelector(".chart-item__bar--fill").style.width =
            100 * (average / portionGrams) * 2 + "%";
        }, 500);

        setTimeout(() => {
          nutrientElement.querySelector(
            ".chart-item__bar--fill"
          ).innerText = `${nutrient.low} - ${nutrient.high}%`;
        }, 1500);
      }
    });

    this.animateValue(0, parseInt(portionGrams), 1500);
  }

  animateValue(start, end, duration) {
    let recommendedPortion = this.querySelector("#recommendedPortion");
    let range = end - start;
    let minTimer = 50;
    let stepTime = Math.abs(Math.floor(duration / range));
    stepTime = Math.max(stepTime, minTimer);
    let startTime = new Date().getTime();
    let endTime = startTime + duration;
    let timer;

    function startCounter() {
      let now = new Date().getTime();
      let remaining = Math.max((endTime - now) / duration, 0);
      let value = Math.round(end - remaining * range);
      recommendedPortion.innerHTML = value;
      if (value == end) {
        recommendedPortion.innerHTML += "g";
        clearInterval(timer);
      }
    }

    timer = setInterval(startCounter, stepTime);
    startCounter();
  }
}

customElements.define("feed-calculator", FeedCalculator);

function calculateProductRecommendationsDosage() {
  let weight = document.querySelector("#weight")?.value;
  let value = parseInt(weight) / 5;
  let recommendations = JSON.parse(
    document.querySelector("#calculator-recommendations")?.textContent
  );
  for (let product of recommendations) {
    let productDosageElm = document.querySelector(
      `.calculator-recommendation__product--${product.id} .calculator-recommendation__product-dosage`
    );
    if (!productDosageElm) return;

    if (
      product.min_dosage &&
      product.max_dosage &&
      product.min_dosage != product.max_dosage
    ) {
      productDosageElm.innerHTML = `${product.translations.dosage} ${(
        product.min_dosage * value
      ).toFixed(1)} – ${(product.max_dosage * value).toFixed(1)} ${
        product.dosage_unit && product.dosage_unit
      }`;
    }

    if (product.min_dosage && product.min_dosage == product.max_dosage) {
      productDosageElm.innerHTML = `${product.translations.dosage} ${(
        product.min_dosage * value
      ).toFixed(1)} ${product.dosage_unit && product.dosage_unit}`;
    }

    if (!product.min_dosage && !product.max_dosage) {
      productDosageElm.innerHTML = product.translations.view_product_for_dosage;
    }
  }
  document
    .querySelector(".calculator-recommendation")
    ?.classList.remove("hidden");
}
